<template>
  <div class="row">
    <div class="col-12">
      <b-row>
        <b-col cols="7">
          <b-row>
            <b-col cols="6" class="ml-2">
              <label for="input-filial">Tipo de folga</label>
              <div>
                <b-form-select
                  id="folgas"
                  v-model="folgaSelecionadaId"
                  :options="tipodefolgas"
                  @input="getFolgas"
                  text-field="folga"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="5" class="ml-2">
              <h6 class="mt-2">Ano selecionado: {{ anoSelecionado }}</h6>
              <b-form-input
                v-model.number="anoSelecionado"
                type="number"
                placeholder="Informe o ano"
                class="mb-3"
                style="max-width: 150px"
                @input="updateFolgaDates"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col
              v-for="month in 12"
              :key="month"
              cols="3"
              class="mb-3 px-1 d-flex justify-content-center"
            >
              <div class="calendar-card-compact p-2 border rounded shadow-sm">
                <h6 class="text-center mb-2">{{ getMonthName(month - 1) }}</h6>
                <table class="table table-bordered table-sm text-center mb-0">
                  <thead>
                    <tr>
                      <th v-for="dayName in weekDays" :key="dayName">
                        {{ dayName }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(week, weekIndex) in generateCalendar(
                        anoSelecionado,
                        month - 1
                      )"
                      :key="weekIndex"
                    >
                      <td
                        v-for="(day, dayIndex) in week"
                        :key="dayIndex"
                        :class="{
                          'text-muted': day === null,
                          'bg-success text-white': isFolga(
                            day,
                            month - 1,
                            anoSelecionado
                          ),
                          'current-date': isCurrentDate(
                            day,
                            month - 1,
                            anoSelecionado
                          ),
                          'clickable-date': day !== null,
                        }"
                        @click="handleDateClick(day, month - 1, anoSelecionado)"
                      >
                        {{ day === null ? "" : day }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="5">
          <b-col cols="12">
            <b-card
              class="card-modern-left-line shadow-gradient"
              align="center"
            >
              <template #header>
                <div class="d-flex align-items-center justify-content-center">
                  <i
                    class="fa fa-plus mr-2"
                    style="font-size: 2.5em; color: #3bc480"
                  ></i>
                  <span class="card-header-text">TOTAL DE FOLGAS</span>
                </div>
              </template>
              <b-card-text>
                <h2>
                  {{ folgas.length }}
                </h2>
              </b-card-text>
            </b-card>
          </b-col>

          <b-form>
            <b-table
              id="tbltabelas"
              class="m-3"
              small
              hover
              striped
              sticky-header="818px"
              :items="folgas"
              :fields="camposFolgas"
            >
              <template #cell(actions)="data">
                <b-button
                  @click="editTabela(data.item)"
                  v-b-modal.modal-multi-corretiva
                  title="Editar tabela"
                  size="sm"
                  variant="success"
                  class="mr-2"
                >
                  <i class="fa fa-exclamation-circle"></i>
                </b-button>
              </template>
            </b-table>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

// Importar componentes do BootstrapVue se ainda não estiverem globalmente registrados
import {
  BRow,
  BCol,
  BFormSelect,
  BFormDatepicker,
  BButton,
  BForm,
  BTable,
  BFormInput,
} from "bootstrap-vue";

export default {
  name: "PlanejamentoEscalaModelo",
  components: {
    Multiselect,
    LoadingModal,
    // Adicione os componentes do BootstrapVue aqui para garantir que estão registrados localmente
    BRow,
    BCol,
    BFormSelect,
    BFormDatepicker,
    BButton,
    BForm,
    BTable,
    BFormInput,
  },
  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];
      valores = this.tabelas.filter((item) => {
        return (
          item.tabela.indexOf(this.search) > -1 ||
          item.carro.indexOf(this.search) > -1 ||
          item.motorista1.indexOf(this.search) > -1
        );
      });
      return valores;
    },

    folgaSelecionada() {
      return this.tipodefolgas.find((f) => f.id === this.folgaSelecionadaId);
    },
  },

  data: function () {
    return {
      isLoading: false,
      mode: "save",
      carregando: false,
      atualizando: false,

      empresas: [],
      tipodefolgas: [],
      folgaSelecionadaId: null,
      dtInicio: "",
      dtTermino: "",
      folgas: [], // Seus dados de folgas para a tabela

      tabela: {},
      tabelas: [],
      tabelasgeradas: [],
      filiais: [],
      tipodias: [],
      periodos: [],
      sentidos: [],
      pontos: [],
      veiculos: [],
      motorista1: [],
      motorista2: [],
      cobrador1: [],
      cobrador2: [],
      veiculo: "",
      search: "",
      quadrohorario: [],
      quadrohorarios: [],
      legendas: [],
      linhasescala: [],
      selectMode: "multi",
      selected: [],

      // Propriedades para os calendários
      anoSelecionado: new Date().getFullYear(), // Define o ano atual como padrão
      weekDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      folgaDates: [], // Armazenará as datas das folgas no formato 'YYYY-MM-DD'
      clickedDate: null, // Nova propriedade para armazenar a data clicada

      camposFolgas: [
        {
          key: "dt_folga",
          label: "Data da folga",
          sortable: true,
          formatter: (value) => {
            return moment(value)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        { key: "folga", label: "Tipo de folga", sortable: true },
        { key: "registro_cadastro", label: "Cadastrado por", sortable: true }, // Corrigido 'Funcionario' para 'Funcionário'

        {
          key: "dt_cadastro",
          label: "Data da do cadastro",
          sortable: true,
          formatter: (value) => {
            return moment(value)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        { key: "registro_alteracao", label: "Alterado por", sortable: true }, // Corrigido 'Funcionario' para 'Funcionário'

        {
          key: "dt_alteracao",
          label: "Data altercao",
          sortable: true,
          formatter: (value, key, folgas) => {
            return moment(folgas.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        {
          key: "status",
          label: "Vigente",
          sortable: true,
          formatter: (value) => (value === true ? "Sim" : "Não"),
        },
      ],
    };
  },

  watch: {
    // Observa mudanças em dtInicio ou dtTermino para ajustar o ano selecionado
    dtInicio(newVal) {
      if (newVal && this.dtTermino) {
        const startYear = new Date(newVal).getFullYear();
        const endYear = new Date(this.dtTermino).getFullYear();
        if (startYear === endYear) {
          this.anoSelecionado = startYear;
        } else {
          this.anoSelecionado = startYear;
        }
      } else if (newVal) {
        this.anoSelecionado = new Date(newVal).getFullYear();
      }
    },
    dtTermino(newVal) {
      if (newVal && this.dtInicio) {
        const startYear = new Date(this.dtInicio).getFullYear();
        const endYear = new Date(newVal).getFullYear();
        if (startYear === endYear) {
          this.anoSelecionado = startYear;
        } else {
          this.anoSelecionado = endYear;
        }
      } else if (newVal) {
        this.anoSelecionado = new Date(newVal).getFullYear();
      }
    },
    // Observa 'folgas' para preencher 'folgaDates' para o calendário
    folgas: {
      handler(newFolgas) {
        this.folgaDates = newFolgas
          .map((f) => {
            return moment(f.dt_folga).format("YYYY-MM-DD");
          })
          .filter((date) => {
            return new Date(date).getFullYear() === this.anoSelecionado;
          });
      },
      deep: true, // Observa mudanças profundas no array de objetos
    },
    // Observa mudanças no anoSelecionado para recarregar as folgas (se o ano mudar manualmente)
    anoSelecionado() {
      this.getFolgas();
    },
  },

  methods: {
    // NOVO MÉTODO PARA TRATAR O CLIQUE NA DATA
    handleDateClick(day, monthIndex, year) {
      if (day === null) {
        return;
      }
      const clickedDate = new Date(year, monthIndex, day);
      const formattedDate = moment(clickedDate).format("YYYY-MM-DD");
      this.clickedDate = formattedDate; // Armazena a data clicada

      // ATUALIZA dtInicio e dtTermino com a data clicada, se for o caso
      // Depende da sua lógica de negócio: a folga é para um dia ou um período?
      this.dtInicio = formattedDate;
      this.dtTermino = formattedDate; // Ou deixe vazio se postFolga for inferir do dtInicio, ou defina um período específico

      this.$bvToast.toast(
        `Data clicada: ${moment(formattedDate).format("DD/MM/YYYY")}`,
        {
          title: "Data Selecionada",
          variant: "info",
          solid: true,
          autoHideDelay: 3000,
        }
      );

      // Agora, chame postFolga().
      // Ela usará this.dtInicio e this.dtTermino (que foram atualizados aqui)
      // e this.folgaSelecionada (que o usuário deve ter selecionado no select).
      this.postFolga();
    },

    getMonthName(monthIndex) {
      const monthNames = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      return monthNames[monthIndex];
    },
    generateCalendar(year, month) {
      const date = new Date(year, month, 1);
      const firstDayOfMonth = date.getDay(); // 0 for Sunday, 1 for Monday...
      const daysInMonth = new Date(year, month + 1, 0).getDate(); // Last day of current month

      let calendar = [];
      let week = Array(7).fill(null);
      let dayCounter = 1;

      // Preencher os dias da semana antes do primeiro dia do mês
      for (let i = 0; i < firstDayOfMonth; i++) {
        week[i] = null;
      }

      // Preencher os dias do mês
      for (let i = firstDayOfMonth; i < 7; i++) {
        week[i] = dayCounter++;
      }
      calendar.push(week);

      while (dayCounter <= daysInMonth) {
        week = Array(7).fill(null);
        for (let i = 0; i < 7 && dayCounter <= daysInMonth; i++) {
          week[i] = dayCounter++;
        }
        calendar.push(week);
      }
      return calendar;
    },
    isFolga(day, monthIndex, year) {
      if (day === null) return false;
      // Formata a data para 'YYYY-MM-DD' para comparação
      const formattedDate = `${year}-${String(monthIndex + 1).padStart(
        2,
        "0"
      )}-${String(day).padStart(2, "0")}`;
      return this.folgaDates.includes(formattedDate);
    },
    isCurrentDate(day, monthIndex, year) {
      if (day === null) return false;
      const today = new Date();
      // Ajusta o mês e ano para corresponder ao calendário
      return (
        day === today.getDate() &&
        monthIndex === today.getMonth() &&
        year === today.getFullYear()
      );
    },
    // Chama getFolgas quando o ano é alterado manualmente no input
    updateFolgaDates() {
      this.getFolgas();
    },

    loadTipoDeFolga() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/escala/tipofolga`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tipodefolgas = res.data.map((td) => ({
            ...td,
            value: td.id,
            folga: td.folga,
            tipo: td.tipo,
          }));
        })
        .catch(showError);
    },

    getFolgas() {
      // Se dtInicio ou dtTermino não estiverem preenchidos,
      // você pode usar o anoSelecionado para buscar as folgas
      // para o ano inteiro.
      let dt_inicio_param = this.dtInicio;
      let dt_termino_param = this.dtTermino;

      // Se as datas não estiverem preenchidas, busca para o ano inteiro selecionado
      dt_inicio_param = `${this.anoSelecionado}-01-01`;
      dt_termino_param = `${this.anoSelecionado}-12-31`;

      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        // Certifique-se de que as datas estão sendo enviadas no formato correto para sua API
        // O `moment` no formatter da tabela converte 'dt_folga' para exibição.
        // Para enviar para a API, se ela espera 'YYYY-MM-DD', certifique-se disso.
        dt_inicio: dt_inicio_param,
        dt_termino: dt_termino_param,
        folga_id: this.folgaSelecionadaId ? `${this.folgaSelecionada.id}` : "", // Envia o ID da folga se selecionado
        funcionario_id: `${this.user.id_funcionario}`,
      };
      const url = `${baseApiUrl}/escala/folga`;
      axios
        .get(url, { params })
        .then((res) => {
          this.folgas = res.data;
          // O watcher de 'folgas' já vai atualizar 'folgaDates'
        })
        .catch(showError);
    },
    async postFolga() {
      if (!this.folgaSelecionada) {
        this.$toasted.global.defaultError({
          message: "Por favor, selecione um tipo de folga.",
        });
        return;
      }
      if (!this.clickedDate) {
        this.$toasted.global.defaultError({
          message: "Por favor, selecione as datas inicial e final.",
        });
        return;
      }

      const corpo = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        dt_folga: `${this.clickedDate}`,
        folga_id: `${this.folgaSelecionada.id}`,
        funcionario_id: `${this.user.id_funcionario}`,
      };

      const url = `${baseApiUrl}/escala/folga`;

      axios
        .post(url, corpo)
        .then((res) => {
          if (res.data && res.data.msg) {
            this.$toasted.global.defaultSuccess({
              msg: res.data.msg,
            });
          }

          this.getFolgas(); // Recarrega as folgas após gerar
        })
        .catch((err) => {
          showError(err);
        });
    },

    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    selectThirdRow() {
      this.$refs.selectableTable.selectRow(2);
    },
    unselectThirdRow() {
      this.$refs.selectableTable.unselectRow(2);
    },

    ready() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
        }
      }, 1000);
    },

    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial };
          });
        })
        .catch(showError);
    },

    loadLinhas() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.tabela.id_filial}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/planejamento/linha/cad`;
      axios
        .get(url, { params })
        .then((res) => {
          this.linhasescala = res.data.map((lin) => {
            return { ...lin, value: lin.id_linha, linha: lin.linha };
          });
        })
        .catch(showError);
    },

    loadTipoDia() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`, // valor_filial não está definido no data
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/planejamento/tipodia`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tipodias = res.data.map((td) => {
            return { ...td, value: td.id, dia: td.dia };
          });
        })
        .catch(showError);
    },

    loadPeriodo() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`, // valor_filial não está definido no data
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/planejamento/periodo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.periodos = res.data.map((per) => {
            return { ...per, value: per.id, periodo: per.periodo };
          });
        })
        .catch(showError);
    },

    loadSentido() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`, // valor_filial não está definido no data
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/planejamento/sentido`;
      axios
        .get(url, { params })
        .then((res) => {
          this.sentidos = res.data.map((se) => {
            return { ...se, value: se.id, sentido: se.sentido };
          });
        })
        .catch(showError);
    },

    loadVeiculo() {
      let corpo = {
        id_empresa: `${this.user.id_empresa}`,
        prefixo: `${this.tabela.id_carro}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.veiculos = res.data.map((lin) => {
            return { ...lin };
          });
        })
        .catch(showError);
    },

    loadLocal() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/planejamento/local`;
      axios
        .get(url, { params })
        .then((res) => {
          this.pontos = res.data.map((po) => {
            return { ...po, value: po.id_ponto, ponto: po.ponto };
          });
        })
        .catch(showError);
    },

    loadBuscaMotorista1() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.id_motorista1}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.motorista1 = res.data.map((mt1) => {
            return { ...mt1 };
          });
        })
        .catch(showError);
    },

    loadBuscaMotorista2() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.id_motorista2}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.motorista2 = res.data.map((op) => {
            return { ...op, value: op.id_funcionario, funcao: op.funcao };
          });
        })
        .catch(showError);
    },

    loadBuscaCobrador1() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.id_cobrador1}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.cobrador1 = res.data.map((op) => {
            return { ...op, value: op.id_funcionario, funcao: op.funcao };
          });
        })
        .catch(showError);
    },

    loadBuscaCobrador2() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.id_cobrador2}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.cobrador2 = res.data.map((op) => {
            return { ...op, value: op.id_funcionario, funcao: op.funcao };
          });
        })
        .catch(showError);
    },

    postTabela() {
      let corpo = {
        psg: this.user.psg,
        id: `${[this.tabela.id]}`,
        id_empresa_grupo: `${[this.user.id_empresa]}`,
        id_empresa: `${[this.tabela.id_empresa]}`,
        id_filial: `${[this.tabela.id_filial]}`,
        id_linha: `${[this.tabela.id_linha]}`,
        tabela: `${[this.tabela.tabela]}`,
        id_tipo: `${[this.tabela.id_tipo]}`,
        id_periodo: `${[this.tabela.id_periodo]}`,
        id_dia: `${[this.tabela.id_dia]}`,
        jornada_inicio: `${this.tabela.jornada_inicio}`,
        jornada_termino: `${[this.tabela.jornada_termino]}`,
        linha_inicio: `${[this.tabela.linha_inicio]}`,
        linha_termino: `${[this.tabela.linha_termino]}`,
        refeicao_inicio: `${[this.tabela.refeicao_inicio]}`,
        refeicao_termino: `${[this.tabela.refeicao_termino]}`,
        id_sentido_inicio: `${[this.tabela.id_sentido_inicio]}`,
        id_sentido_termino: `${[this.tabela.id_sentido_termino]}`,
        id_carro: `${[this.veiculos.map((ve) => ve.id_veiculo)]}`,
        id_motorista1: `${[this.motorista1.map((mt1) => mt1.id_funcionario)]}`,
        id_motorista2: `${[this.motorista2.map((mt2) => mt2.id_funcionario)]}`,
        id_motorista_pegada: `${[this.tabela.id_motorista_pegada]}`,
        id_motorista_largada: `${[this.tabela.id_motorista_largada]}`,
        entrega_feria: `${[this.tabela.entrega_feria]}`,
        motorista_tempo_minuto: `${[this.tabela.motorista_tempo_minuto]}`,
        cobrador_tempo_minuto: `${[this.tabela.cobrador_tempo_minuto]}`,
        noturno: `${[this.tabela.noturno]}`,
        tem_cobrador: `${[this.tabela.tem_cobrador]}`,
        dt_vigencia: `${[this.tabela.dt_vigencia]}`,
        status: `${[this.tabela.status]}`,
        id_funcionario_cadastro: `${[this.user.id_funcionario]}`,
        id_funcionario_alteracao: `${[this.user.id_funcionario]}`,
        id_identificador: `${[this.tabela.id_identificador]}`, // id legenda da programação
        id_cobrador1: `${[this.cobrador1.map((cb1) => cb1.id_funcionario)]}`,
        id_cobrador2: `${[this.cobrador2.map((cb2) => cb2.id_funcionario)]}`,
        id_cobrador_pegada: `${[this.tabela.id_cobrador_pegada]}`,
        id_cobrador_largada: `${[this.tabela.id_cobrador_largada]}`,
      };

      const url = `${baseApiUrl}/planejamento/tabela`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.resetTabela();
        })
        .catch(showError);
    },

    loadTabelas() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_linha: `${this.tabela.id_linha}`,
      };
      const url = `${baseApiUrl}/planejamento/tabelamodelo`;
      axios
        .post(url, { params })
        .then((res) => {
          this.tabelas = res.data.map((tabs) => {
            return { ...tabs };
          });
        })
        .catch(showError);
    },

    loadEscalaGerada() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${[this.tabela.id_filial]}`,
        id_dia: `${[this.tabela.id_dia]}`,
        dt_servico: `${this.tabela.dt_servico}`,
      };
      const url = `${baseApiUrl}/planejamento/escalagerada`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tabelasgeradas = res.data.map((tabs) => {
            return { ...tabs };
          });
          this.isLoading = false;
        })
        .catch(showError);
    },

    loadLegenda() {
      let params = {
        psg: `${this.user.psg}`,
        id_empresa: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/planejamento/escala/legenda`;
      axios
        .get(url, { params })
        .then((res) => {
          this.legendas = res.data.map((le) => {
            return { ...le, value: le.id, legenda: le.legenda };
          });
        })
        .catch(showError);
    },

    postQuadroHorario() {
      let corpo = {
        id: `${[this.quadrohorario.id]}`,
        id_tabela: `${[this.tabela.id]}`,
        id_empresa: `${[this.tabela.id_empresa]}`,
        id_filial: `${[this.tabela.id_filial]}`,
        id_linha: `${[this.tabela.id_linha]}`,
        id_dia: `${[this.tabela.id_dia]}`,
        chegada: `${this.quadrohorario.chegada}`,
        chegada_virada_do_dia: `${this.quadrohorario.chegada_virada_do_dia}`,
        saida: `${this.quadrohorario.saida}`,
        saida_virada_do_dia: `${this.quadrohorario.saida_virada_do_dia}`,
        id_legenda: `${[this.quadrohorario.id_legenda]}`,
        id_funcionario_cadastro: `${[this.user.id_funcionario]}`,
        id_funcionario_alteracao: `${[this.user.id_funcionario]}`,
        id_sentido: `${[this.quadrohorario.id_sentido]}`,
        ponto_id: `${[this.quadrohorario.ponto_id]}`,
        status: `${[this.quadrohorario.status]}`,
        dt_vigencia: `${[this.tabela.dt_vigencia]}`,
      };

      const url = `${baseApiUrl}/planejamento/escala/quadrohorario`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.$toasted.global.defaultSuccess();
          this.resetQuadroHorario();
          this.loadQuadroHorario();
        })
        .catch(showError);
    },

    loadQuadroHorario() {
      let corpo = {
        id_tabela: `${[this.tabela.id]}`,
      };
      const url = `${baseApiUrl}/planejamento/escala/quadrohorario/busca`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.$toasted.global.defaultSuccess();
        })
        .catch(showError);
    },

    editTabela(tabela) {
      this.tabela = { ...tabela };
    },

    editQuadroHorario(quadrohorario) {
      this.quadrohorario = { ...quadrohorario };
    },

    resetTabela() {
      this.tabela.cobrador1 = "";
      this.tabela.id = "";
      this.tabela.tabela = "";
      this.tabela.jornada_inicio = "";
      this.tabela.jornada_termino = "";
      this.tabela.linha_inicio = "";
      this.tabela.linha_termino = "";
    },

    resetQuadroHorario() {
      this.quadrohorario.id = "";
      this.quadrohorario.chegada = "";
      this.quadrohorario.saida = "";
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadTipoDeFolga();
    this.loadTipoDia();
    this.loadPeriodo();
    this.loadSentido();
    this.loadLocal();
    this.loadLegenda();
    // No `mounted`, você pode querer carregar as folgas para o ano atual
    //this.getFolgas();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* Estilos para o calendário mais compacto */
.calendar-card-compact {
  width: 100%; /* Garante que o card ocupe a largura da coluna */
  max-width: 240px; /* Reduzindo o tamanho máximo para caber 4 por linha */
  box-sizing: border-box;
  background-color: #fefefe; /* Fundo mais claro para os cards */
}

/* Ajustes para a tabela dentro dos calendários */
.table.table-bordered th,
.table.table-bordered td {
  padding: 0.2rem !important; /* Reduz o padding para células ainda menores */
  font-size: 0.8rem; /* Reduz o tamanho da fonte */
}

.table.table-bordered th {
  background-color: #e9ecef;
}

.bg-success {
  background-color: #28a745 !important;
}

.text-white {
  color: #fff !important;
}

.text-muted {
  color: #6c757d !important;
}

.current-date {
  border: 2px solid #007bff;
  font-weight: bold;
}

/* Nova classe para células clicáveis */
.clickable-date {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.clickable-date:hover {
  background-color: #e2e6ea; /* Um pouco mais escuro ao passar o mouse */
}

.clickable-date.bg-success:hover {
  background-color: #218838 !important; /* Cor mais escura para folgas ao passar o mouse */
}

/* Seus estilos existentes (mantidos, mas verifique se há conflitos) */
#selecaostatusx {
  font-size: 0.7em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}
</style>